module.exports = __webpack_public_path__ + "img/search-normal-20x20.42bc75c0.svg";